(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsWorkOrderClientDetails', rmsWorkOrderClientDetails);

    function rmsWorkOrderClientDetails() {
        return {
            restrict: 'E',
            scope: {
                details: "=",
                rates: '=?',
            },
            controller: rmsWorkOrderClientDetailsCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'rms/templates/work-orders/work-order-client-details'
        };
    }

    function rmsWorkOrderClientDetailsCtrl() {}
})();